import { Box } from "../../uikit/box";
import { Flex } from "../../uikit/flex";
import { Icon } from "../../uikit/icon";
import { IconButton } from "../../uikit/icon-button";
import { Text } from "../../uikit/text";

import s from "./status-popup.module.scss";

export type StatusPopupIcon =
  | "Conversation"
  | "Information"
  | "Warning"
  | "Error";

interface StatusPopupProps {
  icon?: StatusPopupIcon;
  title: string;
  text: string;
  onClose: () => void;
}

const ICON_NAME_BY_TYPE = {
  Conversation: "question-answer-filled",
  Information: "information",
  Warning: "alert",
  Error: "spam-2",
} as const;

const ICON_COLOR_BY_TYPE = {
  Conversation: "primary-500",
  Information: "blue-500",
  Warning: "yellow-500",
  Error: "red-500",
} as const;

export const StatusPopup = ({
  icon = "Information",
  title,
  text,
  onClose,
}: StatusPopupProps) => {
  return (
    <Box className={s.root} p="16" rad="12" bgColor="base-0">
      <Flex g="6" ai="flex-start">
        <Box className={s.icon} p="6" rad="8" bgColor="base-50">
          <Icon
            name={ICON_NAME_BY_TYPE[icon]}
            s="24"
            color={ICON_COLOR_BY_TYPE[icon]}
          />
        </Box>

        <Box>
          <Text s="callout-bold">{title}</Text>
          <Text s="sub-headline" mt="8" color="text-500">
            {text}
          </Text>
        </Box>
      </Flex>

      <IconButton
        className={s.closeButton}
        variant="secondary"
        s="s"
        icon="close"
        onClick={onClose}
      />
    </Box>
  );
};
